import React from "react";
import PropTypes from "prop-types";
import CurrencyFormat from "react-currency-format";
import {isNull} from "lodash";

function PriceFormatted(props) {
  const {value} = props;

  if (isNull(value))
    return ;

  return <CurrencyFormat {...props} value={value} displayType="text" thousandSeparator={' '} decimalSeparator={'.'} decimalScale={props.decimalScale} fixedDecimalScale={true} />
}

PriceFormatted.defaultProps = {
  decimalScale: 2,
};

PriceFormatted.propTypes = {
  value: PropTypes.number,
  decimalScale: PropTypes.number,
};

export default PriceFormatted;
